import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Flex, Input } from 'antd';
import dayjs from 'dayjs';

import { DATE_PICKER_FORMAT } from '@app/constants';

import type { FiltersEmailLogsType } from '@pages/EmailLogs/types';

const { RangePicker } = DatePicker;

export const Filters: FiltersEmailLogsType = ({
  values: { dateE, dateS, module, level, searchText },
  setFilters,
  onSearch,
  onReset,
  disabled,
}) => (
  <Flex vertical gap={16}>
    <Input
      placeholder="Поиск по ID, сообщению, properties"
      value={searchText || undefined}
      allowClear
      disabled={disabled}
      onChange={(e) =>
        setFilters((prev) => ({
          ...prev,
          searchText: e.target.value || '',
        }))
      }
      style={{ width: 400 }}
    />
    <Flex className={'filters'} align="center" wrap="wrap" gap={12}>
      <RangePicker
        showTime
        value={[dateS ? dayjs(dateS) : null, dateE ? dayjs(dateE) : null]}
        onChange={(dates) => {
          setFilters((prev) => ({
            ...prev,
            dateS: dates?.[0]?.format('YYYY-MM-DDTHH:mm:ss') || '',
            dateE: dates?.[1]?.format('YYYY-MM-DDTHH:mm:ss') || '',
          }));
        }}
        className={'filters_date'}
        placeholder={['Дата с', 'Дата по']}
        disabled={disabled}
        format={DATE_PICKER_FORMAT}
      />

      <Input
        placeholder="Уровень"
        value={level || undefined}
        allowClear
        disabled={disabled}
        onChange={(e) =>
          setFilters((prev) => ({
            ...prev,
            level: e.target.value || '',
          }))
        }
        style={{ width: 200 }}
      />

      <Input
        placeholder="Модуль"
        value={module || undefined}
        allowClear
        disabled={disabled}
        onChange={(e) =>
          setFilters((prev) => ({
            ...prev,
            module: e.target.value || '',
          }))
        }
        style={{ width: 200 }}
      />

      <div className={'filters_buttons'}>
        <Button
          htmlType="reset"
          onClick={onReset}
          className={'filters_buttons_item'}
        >
          <CloseCircleOutlined />
          Сброс
        </Button>
        <Button
          type="primary"
          onClick={onSearch}
          className={'filters_buttons_item'}
        >
          Показать
        </Button>
      </div>
    </Flex>
  </Flex>
);
